import { render, staticRenderFns } from "./nxLoadMore.vue?vue&type=template&id=3c57fec4&scoped=true&"
import script from "./nxLoadMore.vue?vue&type=script&lang=js&"
export * from "./nxLoadMore.vue?vue&type=script&lang=js&"
import style0 from "./nxLoadMore.vue?vue&type=style&index=0&id=3c57fec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c57fec4",
  null
  
)

export default component.exports